var styles = {"row":"styles_row__2iSCM flex items-center","indicator":"styles_indicator__1nwU9 flex items-center justify-around mr1","dot":"styles_dot__3wmnC","blink":"styles_blink__3Ow5s","paused":"styles_paused__2soLN styles_indicator__1nwU9 flex items-center justify-around mr1","typing":"styles_typing__3fEY1 styles_indicator__1nwU9 flex items-center justify-around mr1"};

export default styles;
//# sourceMappingURL=styles.css.js.map
